export default "__VITE_ASSET__50f82232__"